import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import {MAIN_APP} from '../../../MidiPlay.jsx';
// import Colors from '../../../resource/ResourceColors.jsx';

const SideBar = styled.div`
    height: 100%;
    top: 0;
    padding: 0.15rem
`;

const MidiClockText = styled.div`
    font-family: Courier;
    font-weight: bold;
    font-size: 0.75rem;
`;

export class SidebarMidiClockEvents extends Component {

    static propTypes = {
        time_division: PropTypes.number.isRequired,
    }

    state = {
        bpm: 0
    };

    componentDidMount() {
        const that = this;
        const bpm_factor = 10 * 60000 * that.props.time_division;
        setInterval(function () {
            if (!MAIN_APP.state.playing) {
                that.setState({bpm: 0})
                return;
            }
            const current_event = MAIN_APP.state.current_event;
            const bpm = Math.floor(bpm_factor / current_event.midi_clock) / 10;
            if (bpm !== that.state.bpm) {
                that.setState({bpm: bpm})
            }
        }, 1000);
    }

    render() {
        const text = this.state.bpm > 1 ? this.state.bpm + ' bpm' : '--'
        return <SideBar>
            <MidiClockText>{text}</MidiClockText>
        </SideBar>
    }
}

export default SidebarMidiClockEvents;

